import { createAction } from 'redux-actions'

const ns = 'activity-management/'

export const getCurrentGoalExport = createAction(`${ns}GET_CURRENT_GOAL_EXPORT`)
export const getChatMessagesExport = createAction(`${ns}GET_CHAT_MESSAGES_EXPORT`)
export const getChatImagesExport = createAction(`${ns}GET_CHAT_IMAGES_EXPORT`)
export const getCurrentLeaderboard = createAction(`${ns}GET_CURRENT_LEADERBOARD`)
export const getCurrentGoalActivityList = createAction(`${ns}GET_CURRENT_GOAL_ACTIVITY_LIST`)
export const getCurrentGoalActivityListSuccess = createAction(`${ns}GET_CURRENT_GOAL_ACTIVITY_LIST_SUCCESS`)
export const getCurrentGoalActivityListFail = createAction(`${ns}GET_CURRENT_GOAL_ACTIVITY_LIST_FAIL`)
export const getCurrentGoalActivityListClear = createAction(`${ns}GET_CURRENT_GOAL_ACTIVITY_LIST_CLEAR`)
export const getCurrentCompanyGoal = createAction(`${ns}GET_CURRENT_COMPANY_GOAL`)
export const getCurrentCompanyGoalSuccess = createAction(`${ns}GET_CURRENT_COMPANY_GOAL_SUCCESS`)
export const getCurrentCompanyGoalFail = createAction(`${ns}GET_CURRENT_COMPANY_GOAL_FAIL`)
export const cancelGetChallengesWithProgress = createAction(`${ns}CANCEL_GET_CHALLENGES_WITH_PROGRESS`)
export const joinGoal = createAction(`${ns}JOIN_GOAL`)
export const leaveGoal = createAction(`${ns}LEAVE_GOAL`)
export const setParticipating = createAction(`${ns}SET_PARTICIPATING`)

export const setActivityListTab = createAction(`${ns}SET_ACTIVITY_LIST_TAB`)
export const setActivityListTypeTab = createAction(`${ns}SET_ACTIVITY_LIST_TYPE_TAB`)

export const setActivityFilter = createAction(`${ns}SET_ACTIVITY_FILTER`)
export const setActivityView = createAction(`${ns}SET_ACTIVITY_VIEW`)
export const setGroupSum = createAction(`${ns}SET_GROUP_SUM`)
export const setGroupView = createAction(`${ns}SET_GROUP_VIEW`)

export const getSingleChallengeWithProgress = createAction(`${ns}GET_SINGLE_CHALLENGE_WITH_PROGRESS`)
export const getSingleChallengeWithProgressSuccess = createAction(`${ns}GET_SINGLE_CHALLENGE_WITH_PROGRESS_SUCCESS`)
